import React, { useContext, useEffect, useState } from 'react'
import { get_invoices, get_subscriber_info } from '../../../services/api/Mocks';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Card, device, Grey_Link, logo, Main_, On_Click_Card, PageAlwaysVisible, PageFull, PageSixty, PageTitle, ThemeContext } from 'monica-alexandria';
import { useTranslation } from 'react-i18next';
import { Lois_Subscriber_Invoices } from './partials/Lois_Subscriber_Invoices';


const LoisSubscriber = styled.div`
`

const PageTitleInner= styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`

const SubscriberInfo = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 1rem;
  gap:1rem; 

  @media ${device.sm} {
   
    display: block;
    padding-left: 1rem;
    padding-bottom: 2rem;
  }

`

const SubscriberInfoInner = styled.div`
  display: flex;
  align-items: center;
  gap:1rem; 

  img{
    width: 3.5rem;
    height: 3.5rem;
    border-radius: var(--smallRadius);
  }

  @media ${device.sm} {
    align-items: left;
  }
`


const SubscriberInfoUser = styled.div`
 border-radius: var(--smallRadius);
  background: ${p=>p.theme.mid};
  padding: var(--smallRadius);
  display: flex;
  align-items: center;
  gap: .5rem;
  @media ${device.sm}{
    flex-direction: column;
    align-items: start;
    width: 100%;

  }
`

const SubscriberCard = styled(Card)`
  cursor: pointer;
  background: ${p => p.theme.low};
  padding: 1rem 2rem;
  margin-bottom: 2rem;
`

const SubscriptionCardGrid = styled.div`

  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 2rem;
  grid-row-gap: .5rem;

  padding: 1rem 2rem;

  @media ${device.lg} {
    grid-template-columns: 1fr;
  }

  @media ${device.md} {
    grid-template-columns: auto 1fr;
  }

  @media ${device.sm} {
    grid-template-columns: 1fr;
  }
`

const SubscriptionCardLeft = styled.div`
    width: 100%;
  `

const SubscriptionCardAmountPaid = styled.div`

  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  @media ${device.sm}{
    flex-direction: column;
    gap: 0;
  }
`
const SubscriptionCardAmountPaidInner = styled.div`
  display: flex;
  align-items: baseline;
  h1{
    font-size: 4rem;
    text-align: center;
  }
`

export default function LOIS_SUBSCRIBER() {

        const params = useParams();

        const {t} = useTranslation();
        const {theme} = useContext(ThemeContext);
        const navigate = useNavigate();
        const [subscriber, setSubscriber] = useState('')
        const [selectedSub, setSelectedSub] = useState(false)
        
        
        const fetchSubscriberInfo = (payload = {}) => {
        const { startDate, endDate } = payload;
    
        get_subscriber_info({ userId: params?.id, startDate, endDate })
            .then((res) => {
                console.log("RESSS", res);
                setSubscriber({ ...subscriber, subs: res?.data?.subs, info: res?.data?.user });
            })
            .catch((err) => {
                console.error("Error fetching subscriber info:", err);
            });
    };
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
    const loisSubs = subscriber?.subs?.filter(sub=> sub?.category === 'lois');


    console.log('loisSubs', loisSubs);
  
    useEffect(() => {
      fetchSubscriberInfo();
    }, []);

  return (
    <LoisSubscriber>
      {selectedSub?
        <Lois_Subscriber_Invoices
          setSelectedSub={setSelectedSub}
          selectedSub={selectedSub}
          userId={params?.id}
        />
    
      : null}
      <PageFull>
       <PageTitle cta>
        <PageTitleInner>
          <Grey_Link iconLeft='Back' noPadding onClick={()=>navigate(`/${params.lang}/akihiko/griphook/subscribers/${params?.id}`)}/>
          <h1>Adsnap</h1>
        </PageTitleInner>
        {/* <Main_ text='Filters' iconLeft='Filter' onClick={()=>toggleFilters(true)}/> */}
      </PageTitle>
      </PageFull>
      <PageSixty>
        <PageAlwaysVisible>
          <SubscriberInfo>
            <SubscriberInfoInner>
              <img src={logo.lois[theme]} title='Adsnap'/>
              <SubscriberInfoUser>
                <h6>{subscriber?.info?.username} |</h6>
                <h6>{subscriber?.info?.firstname} {subscriber?.info?.lastname}</h6>
              </SubscriberInfoUser>
            </SubscriberInfoInner>
            {/* <p>Created at: {new Date(subscriber?.info?.createdAt).toLocaleDateString('el-GR')} </p> */}
          </SubscriberInfo>
        {loisSubs?.map((subscription) => (
          <SubscriberCard key={subscription._id} onClick={()=> setSelectedSub(subscription?.cusId)}  >
              <SubscriptionCardLeft>      
                <SubscriptionCardAmountPaid>
                  <SubscriptionCardAmountPaidInner>
                    <h1>€{subscription.price/100}</h1>
                    <h5>,00</h5>
                  </SubscriptionCardAmountPaidInner>
                    <h5>(VAT incl.)</h5>
                </SubscriptionCardAmountPaid>
                  <SubscriptionCardGrid>
                    <p>{t("Payment interval")}:</p>
                    <h5>{t("30 days")}</h5>
                    <p>{t("Subscription Status")}:</p>
                    <h5>{subscription.status}</h5>
                    <p>{t("Next payment")}:</p>
                    <h5>
                      {!subscription.subscriptionCancelOnPeriodEnd
                        ? new Date(subscription.current_period_end).toLocaleDateString()
                        : t("Next scheduled payment canceled")}
                    </h5>
                    {subscription.amountTopUp ? (
                      <>
                        <p>{t("Next invoice is set to")}:</p>
                        <h5>€ {subscription.amountTopUp / 100},00</h5>
                      </>
                    ) : null}
                  </SubscriptionCardGrid>
              </SubscriptionCardLeft>
  
          </SubscriberCard>
        ))}
        
          </PageAlwaysVisible>
      </PageSixty>
    </LoisSubscriber>
  )
}
